import "./sectionTitle.css"

export function SectionTitle({ title }){
    return (
        <div className="d-flex align-items-center gap-3">
            <div className="section-title-rectangle"></div>
            <div className="secion-title">{title}</div>
        </div>
    )
}